import { Box, CircularProgress, Typography } from '@mui/material'
import axios, { AxiosError } from 'axios'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { FormPackageLinkModel, FormPackageLinkType } from '../../api/DTOtemp'
import AuthenticationProviderInstancesClient from '../../api/clients/authenticationProviders/AuthenticationProviderInstancesClient'
import { FormPackageLinksClient } from '../../api/clients/identity'
import { SessionService } from '../../services/session'

export const LinkResolutionPage = () => {
	const { linkId } = useParams<{ linkId: string }>()
	const history = useHistory()
	const sessionService = SessionService.getInstance()

	const searchParams = new URLSearchParams(location.search)

	const [formPackageLink, setFormPackageLink] = useState<
		FormPackageLinkModel | undefined
	>()
	const [loadError, setLoadError] = useState<
		AxiosError<unknown, unknown> | undefined
	>()

	useEffect(() => {
		const linkClient = new FormPackageLinksClient()
		const providerInstanceClient = new AuthenticationProviderInstancesClient()

		;(async () => {
			try {
				const { data: link } = await linkClient.getLink(linkId)

				let redirectRoute = `/_package-host/${link.formPackageId}`

				// there is an easier way with searchParams.size but tslint has not picked up on that yet
				if (searchParams !== undefined && searchParams.toString() !== '')
					redirectRoute += `?${searchParams.toString()}`

				if (link.type === FormPackageLinkType.Internal) {
					/* internal links don't allow for auth urls since they're internal
				 also the only anonymous internal one we should ever have is the
				 FIM anonymous, which will sign in the user in the package route */
					sessionService
						.signInAnonymous()
						.then(() => {
							history.push(redirectRoute)
						})
						.catch((e) => {
							console.error(e)
							if (axios.isAxiosError(e)) setLoadError(e)
						})
					return
				}

				const { data: redirectUri } =
					await providerInstanceClient.getAuthenticationUrl(
						link.authenticationProviderId,
						redirectRoute,
					)

				history.push(redirectUri)
			} catch (e) {
				console.error(e)
				if (axios.isAxiosError(e)) setLoadError(e)
			}
		})()
	}, [])

	if (loadError)
		return (
			<Box
				display={'flex'}
				height={'100%'}
				width={'100%'}
				flex="1"
				justifyContent={'center'}
				alignItems={'center'}
				flexDirection={'column'}
			>
				<Typography variant="h5" paddingBottom={2}>
					Failed to Resolve Link
				</Typography>

				<Typography>
					Please Contact the Site Owner and inform them of this issue
				</Typography>

				<Typography variant="subtitle1">{loadError.message}</Typography>
			</Box>
		)

	if (formPackageLink === undefined)
		return (
			<Box
				height={'100%'}
				width={'100%'}
				display={'flex'}
				flex="1"
				justifyContent={'center'}
				alignItems={'center'}
				flexDirection={'column'}
			>
				<Typography variant="h5" paddingBottom={2}>
					Loading Form Package...
				</Typography>

				<CircularProgress />
			</Box>
		)

	return (
		<>
			<div></div>
		</>
	)
}
